import { Button, Grid } from '@material-ui/core';
import { GridPagination } from '@material-ui/data-grid';
import DeleteIcon from '@material-ui/icons/Delete';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import { useContext } from 'react';
import { AppContext } from '../../../context/context';
import { useLocation } from 'react-router-dom';

const AdminDelete = (props: any) => {
	const {
		state: {
			selection
		},
		api: {
			current: {
				componentsProps: {
					footer: {
						dataObject,
						deletableContent,
						checkable,
						overide
					}
				}
			}
		}
	} = props	
	
	const { sharedData: { isLogged } , setSharedData } = useContext(AppContext);
	const payload = Object.keys(selection).map((id: string) => { return parseInt(id) })
	const location = useLocation().pathname.split("/")[1].toLowerCase();
	const deleteHandler = () => {	
		if (location === "campaign") {
			dataObject.campaign.DELETE(payload)
			return
		}
		dataObject.campaigns.DELETE(payload)
	}

	return (
		<Grid container justify="flex-end">
			{isLogged && checkable && deletableContent && payload.length > 0 ?
				<Grid item xs={9} sm={9} md={4} lg={5}>
					<Button
						style={{
							marginTop: 8,
							color: "white",
							backgroundColor: "#ff1744",
						}}
						startIcon={<DeleteIcon />}
						onClick={deleteHandler}>Delete</Button>
				</Grid>
				: isLogged && overide && location !== "campaigns" &&
				<Grid container justify="flex-end" style={{marginTop:10}}>
					{payload.length > 0 && 
					<Grid item xs={9} sm={9} md={4} lg={2}>
						<Button onClick={() => {
							setSharedData((prevState: any) => ({ ...prevState, isModalActive: false, modalTarget: "", modalPayload:payload}))
						}} variant="contained" color="primary" size={"large"} startIcon={<DoneIcon />} >Done</Button>
					</Grid>}
					<Grid item xs={9} sm={9} md={4} lg={payload.length > 0? 6 : 7}>
						<Button
							color="secondary"
							size={"large"}
							variant="contained"
							startIcon={<ClearIcon />}
							onClick={() => {
								setSharedData((prevState: any) => ({ ...prevState, modalPayload:[], isModalActive: false, modalTarget:""}))
							}}>
							Cancel
						</Button>
					</Grid>
				</Grid>}
			<Grid item>
				<GridPagination />
			</Grid>
		</Grid>
	);
}

export default AdminDelete;
